import { render, staticRenderFns } from "./promotionsImport.vue?vue&type=template&id=b2144a92&"
import script from "./promotionsImport.vue?vue&type=script&lang=js&"
export * from "./promotionsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports